import { countriesToTextMapper } from "../data_models/data/countries";

export const fullAddressString = (streetAddress?: string | null,
    streetAddress2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    country?: string | null) => {

    let address = '';
    if (streetAddress && streetAddress.trim().length > 0) {
        address += streetAddress;
    }
    if (streetAddress2 && streetAddress2.trim().length > 0) {
        address += ', ' + streetAddress2;
    }
    if (city && city.trim().length > 0) {
        address += ', ' + city;
    }
    if (state && state.trim().length > 0) {
        address += ', ' + state;
    }
    if (zipCode && zipCode.trim().length > 0) {
        address += ', ' + zipCode;
    }
    if (country && country.trim().length > 0) {
        address += ', ' + countriesToTextMapper(country);
    }
    if (address.trim().length > 0)
        return address;

}
